export const BRAND = {
  name: "ميرال كروب",
  nameEn: "Miral Group",
  tagline: "حلولك المالية الذكية",
  phone: "0591361091",
  whatsappIntl: "966591361091",
};

export const WHATSAPP_LINK = (msg = "السلام عليكم، أرغب في الاستفسار عن خدمة السيولة من ميرال كروب") =>
  `https://wa.me/${BRAND.whatsappIntl}?text=${encodeURIComponent(msg)}`;

export const HERO_IMAGE = "https://customer-assets.emergentagent.com/job_quick-sarf/artifacts/ilg37k9w_IMG_6516.png";
export const ABOUT_IMAGE = "https://customer-assets.emergentagent.com/job_quick-sarf/artifacts/pt2xzvls_D77ADA50-6031-4A0E-938F-108755767DE5.png";

export const TABBY_LOGO = "https://customer-assets.emergentagent.com/job_quick-sarf/artifacts/9v7mas1i_IMG_6959.png";
export const TAMARA_LOGO = "https://customer-assets.emergentagent.com/job_quick-sarf/artifacts/q05rjnin_IMG_6960.jpeg";

export const PRICING_TIERS = [
  { request: 1000, receive: 1025 },
  { request: 1500, receive: 1550 },
  { request: 2000, receive: 2100 },
  { request: 2500, receive: 2600 },
  { request: 3000, receive: 3150 },
  { request: 5000, receive: 5200 },
  { request: 10000, receive: 10400 },
  { request: 15000, receive: 15600 },
  { request: 25000, receive: 26000 },
];
